var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6089 6.47484C14.5505 6.4665 14.4922 6.4665 14.4339 6.47484C13.1422 6.43317 12.1172 5.37484 12.1172 4.07484C12.1172 2.74984 13.1922 1.6665 14.5255 1.6665C15.8505 1.6665 16.9339 2.7415 16.9339 4.07484C16.9255 5.37484 15.9005 6.43317 14.6089 6.47484Z",
    fill: "#878787"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3257 12.2498C16.3923 12.8748 15.084 13.1082 13.8757 12.9498C14.1923 12.2665 14.359 11.5082 14.3673 10.7082C14.3673 9.87485 14.184 9.08318 13.834 8.39151C15.0673 8.22485 16.3757 8.45818 17.3173 9.08318C18.634 9.94985 18.634 11.3748 17.3257 12.2498Z",
    fill: "#878787"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36745 6.47484C5.42578 6.4665 5.48411 6.4665 5.54245 6.47484C6.83411 6.43317 7.85911 5.37484 7.85911 4.07484C7.85911 2.7415 6.78411 1.6665 5.45078 1.6665C4.12578 1.6665 3.05078 2.7415 3.05078 4.07484C3.05078 5.37484 4.07578 6.43317 5.36745 6.47484Z",
    fill: "#878787"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45794 10.7083C5.45794 11.5167 5.63294 12.2833 5.94961 12.975C4.77461 13.1 3.54961 12.85 2.64961 12.2583C1.33294 11.3833 1.33294 9.95834 2.64961 9.08334C3.54128 8.48334 4.79961 8.24167 5.98294 8.37501C5.64128 9.07501 5.45794 9.86667 5.45794 10.7083Z",
    fill: "#878787"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 13.225C10.0333 13.2167 9.95833 13.2167 9.88333 13.225C8.35 13.175 7.125 11.9167 7.125 10.3667C7.13333 8.78333 8.40833 7.5 10 7.5C11.5833 7.5 12.8667 8.78333 12.8667 10.3667C12.8583 11.9167 11.6417 13.175 10.1 13.225Z",
    fill: "#878787"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39102 14.9502C6.13268 15.7919 6.13268 17.1752 7.39102 18.0085C8.82435 18.9669 11.1743 18.9669 12.6077 18.0085C13.866 17.1669 13.866 15.7835 12.6077 14.9502C11.1827 13.9919 8.83268 13.9919 7.39102 14.9502Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.4227efe6c9fd4ca619bff886db156416.svg";
export { ForwardRef as ReactComponent };